import {Component, OnInit,Input, Inject} from 'ng-metadata/core';
import {FeaturedResultsService} from './featuredResults.service';
import {STATE_NAMES} from "../../../primoExplore/primoExploreStates.module";
import {getVid} from '../../../appConfig/appConfigForward';
import {ScrollService} from "../../scroller/scroll.service";
import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";
import {beacon, PrimolyticsService} from "../../../analytics/primolytics.service";

const get= require('lodash/get');

@Component({
    selector: 'prm-featured-results',
    templateUrl: 'components/search/searchResult/featuredResults/featured-results.html',
})

export class PrmFeaturedResults implements OnInit{
    @Input()  featuredResults;
    private offseterElem;
    private featuredContent;
    private featuredItems;
    private LEFT= 'LEFT';
    private RIGHT= 'RIGHT';
    private nextBeaconCalledOnce: boolean = false;
    private previousBeaconCalledOnce: boolean = false;
    private KEY_CODE= {
        LEFT_ARROW : 37,
        RIGHT_ARROW : 39
    };
    constructor(@Inject('$state') private $state: ng.ui.IStateService,
                @Inject('actionIcons') private  actionIcons: Object,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
				@Inject('$interval') private $interval: ng.IIntervalService,
                private scrollService:ScrollService,
                private configurationUtil: ConfigurationUtil,
                private primolyticsService: PrimolyticsService) {
    }

    ngOnInit() {
        if('personPage'===get(this.featuredResults,'cameFrom','')){
            this.setPersonPageOffseterElem();            
        }else{
            this.offseterElem = document.querySelector(".horizontal-content-scroller");    
            this.featuredContent = document.querySelector(".horizontal-content-scroll-offseter");
            this.featuredItems = this.offseterElem.getElementsByTagName("prm-featured-result-item");
        }        
    }

    private setPersonPageOffseterElem() {
        this.$timeout(() => {
            this.offseterElem = document.querySelector("." + this.featuredResultsElementId);
            if (this.offseterElem) {
                this.featuredContent = this.offseterElem.querySelector(".horizontal-content-scroll-offseter");
                this.featuredItems = this.offseterElem.getElementsByTagName("prm-featured-result-item");
            }            
        }, 100);
    }

    get leftArrowShowing():boolean{
        return this.scrollService.isShowLeftArrow(this.offseterElem);
    }

    get isShowRightArrow():boolean{
        return this.scrollService.isShowRightArrow(this.offseterElem)
    }

    get featuredResultItems(){
        return this.featuredResults.featuedResultsItems;
    }

    public searchParam() {
        let mode: string = this.featuredResults.resourceType === "all_items" ? undefined : "advanced";
        let pFilterMo = this.configurationUtil.isSuprima()?'rtype':'pfilter';
        let pfilter: string = mode != undefined ? pFilterMo + ",exact," + this.featuredResults.resourceType : undefined;
        let advanceOp:string = mode?   ',AND' :'';
        return {
            tab: this.featuredResults.moreTab,
            search_scope: this.featuredResults.searchScopeSet,
            vid: getVid(),
            mode: mode,
            pfilter: mode?pfilter + advanceOp : undefined,
            query: this.$state.params['query'] + advanceOp,
            came_from: "featuredResults"
        }
    }

    get showLeftBar():boolean{
        return !(this.$state.current.name === STATE_NAMES.PERSON_ENTITY_PAGE);
    }

    get isSuprima(){
    	return this.configurationUtil.isSuprima();
    }

    public searchLink(){
        return this.$state.href(STATE_NAMES.SEARCH, this.searchParam(), {lossy:true});
    }

    public scrollContent(direction:string){
        this.sendScrollDirectionBeacon(direction === 'left' ? this.LEFT : this.RIGHT);
        this.scrollService.smoothScrollClick(direction, this.offseterElem,this.featuredItems);
    }

    get tab(){
        return this.featuredResults.moreTab;
    }

    get scope(){
        return this.featuredResults.searchScopeSet;
    }

    get featuredResultsElementId() {
        return ('personPage' === get(this.featuredResults,'cameFrom')) ? get(this.featuredResults,'title','')+'-horizontal-content-scroller' : '';
    }

    get title() {
        return this.featuredResults.barTitle;
    }

    get adaptor(){
        return this.featuredResults.searchLocations;
    }
    get type(){
        return this.featuredResults.resourceType;
    }


    get format(){
        return this.featuredResults.format;
    }

	get totalHits(){
        return this.featuredResults.totalHits;
    }

    public handleKeyUp(e){
        let keyCodes = this.KEY_CODE;
        switch (e.keyCode) {
            case keyCodes.LEFT_ARROW:
                    this.sendScrollDirectionBeacon(this.LEFT);
                break;
            case keyCodes.RIGHT_ARROW:
                    this.sendScrollDirectionBeacon(this.RIGHT);
                break; 
        }
    }

    @beacon({'p':'featuredResults', 'op':'displayAllResults'})
    public sendDisplayAllResultsBeacon(){}

    private sendScrollDirectionBeacon(direction){
        if(!this.previousBeaconCalledOnce && direction === this.LEFT){
            this.sendPreviousInFeaturedResultsBeacon();
            this.previousBeaconCalledOnce = true;
        }else if(!this.nextBeaconCalledOnce && direction === this.RIGHT){
            this.sendNextInFeaturedResultsBeacon();
            this.nextBeaconCalledOnce = true;
        }
    }

    @beacon({'p':'featuredResults', 'op':'previousInFeaturedResults'})
    private sendPreviousInFeaturedResultsBeacon(){}

    @beacon({'p':'featuredResults', 'op':'nextInFeaturedResults'})
    private sendNextInFeaturedResultsBeacon(){}

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/featuredResults/featuredResults.directive.ts